import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin, Typography, App } from 'antd';
import { PASSGATE_RETURN_PATH_KEY } from '@/common/auth/passgateTokens';
import { setLoginTokens } from '@/common/auth/tokens';
import { resetCurrentUserCache } from '@/common/auth/adminAcl';

const { Text } = Typography;

/**
 * Passgate 登录完成后的落地页：从 URL hash 读取 access_token / refresh_token。
 * 约定：/callback/login#access_token=...&refresh_token=...
 */
export default function PassgateCallbackPage() {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [err, setErr] = useState<string | null>(null);
  const consumed = useRef(false);

  useEffect(() => {
    if (consumed.current) return;
    consumed.current = true;

    const hash = window.location.hash?.replace(/^#/, '') || '';
    const params = new URLSearchParams(hash);
    const access = params.get('access_token');
    const refresh = params.get('refresh_token');

    if (!access) {
      const msg = '登录回调未返回 access_token，请重试或联系管理员';
      setErr(msg);
      message.error(msg);
      navigate('/user-login', { replace: true });
      return;
    }

    setLoginTokens('passgate', access, refresh);
    resetCurrentUserCache();
    // 清除 hash，避免 token 留在地址栏
    const clean = `${window.location.pathname}${window.location.search}`;
    window.history.replaceState(null, '', clean);

    const returnPath = sessionStorage.getItem(PASSGATE_RETURN_PATH_KEY) || '/';
    sessionStorage.removeItem(PASSGATE_RETURN_PATH_KEY);
    navigate(returnPath, { replace: true });
  }, [navigate, message]);

  if (err) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      >
        <Text type="danger">{err}</Text>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', gap: 16,
    }}
    >
      <Spin size="large" />
      <Text type="secondary">正在完成登录…</Text>
    </div>
  );
}
